var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnArchive = function SvgUnArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 81"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m39.232 14.912-6.914 6.182a.9.9 0 0 0 0 1.374 1.18 1.18 0 0 0 1.537 0l5.059-4.524V46.5h2.172V17.944l5.06 4.524a1.18 1.18 0 0 0 1.536 0 .9.9 0 0 0 0-1.374l-6.914-6.182a1.18 1.18 0 0 0-1.536 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m68.54 47.262-9.225-23.77H49.44a2.9 2.9 0 0 0 .547-2h10.699L71.03 48.156l-3.725 22.352H12.49L8.97 48.152l10.345-26.66h10.7a2.9 2.9 0 0 0 .546 2h-9.876l-9.224 23.77h10.838l12 7.87H45.7l12-7.87zm-2.928 21.246 3.208-19.246H58.299l-12 7.87H33.7l-12-7.87H11.17l3.03 19.246z",
    clipRule: "evenodd"
  })));
};
export default SvgUnArchive;